import x1 from './cse-top-pick-circle-2019.png'
import x2 from './cse-top-pick-circle-2019@2x.png'
import x3 from './cse-top-pick-circle-2019@3x.png'

export const cseTopPickAttrs = {
  src: x1,
  srcSet: `${x2} 2x, ${x3} 3x`,
}
